import React, { useEffect, useRef } from "react";
import {
  Wrapper,
  ImageWrapper,
  DragImageWrapper,
  DragImage,
} from "../styles/components/Global/Loader";
import { mm } from "../styles/variables/MatchMedia";
import { BREAKPOINTS } from "../styles/variables/Breakpoints";
import animations from "./Animations";

const Loader = () => {
  const wrapperRef = useRef(null);
  const imageRefs = useRef([null, null]);

  const imageSources = [
    "https://www.datocms-assets.com/40484/1700761313-a-ap-mask.png",
    "https://www.datocms-assets.com/40484/1700761317-rockyp-mask.png",
  ];

  useEffect(() => {
    const mediaMatcher = mm();
    const context = mediaMatcher.contexts[0].conditions;

    window.history.scrollRestoration = "manual";

    window.scrollTo(0, 0);
    if (window.scrollY === 0 && context.isDesktop) {
      document.body.classList.toggle("disable-scroll", true);
    }

    let observer;

    const initLoader = () => {
      const timeOut = context.isDesktop ? 6500 : 3000;
      const sections = imageRefs.current;

      let left = sections[0]?.querySelector(".drag");
      let right = sections[1]?.querySelector(".drag");

      const scaleWrap = animations.utils.wrap(0, 1);

      const handleMove = event => {
        wrapperRef.current?.classList.toggle("grabbing", event.isDragging);

        const currentX = event.x;
        const width = window.innerWidth;

        const scaleX = scaleWrap(currentX / width);

        const tl = animations.timeline({});

        tl.to(
          left,
          {
            scaleX: scaleX,
            scaleY: 0.5,
            transformOrigin: "center left",
            duration: 0.1,
          },
          0
        ).to(
          right,
          {
            scaleX: 1 - scaleX,
            scaleY: 0.5,
            transformOrigin: "center right",
            duration: 0.1,
          },
          0
        );
      };

      mediaMatcher.add(`(min-width: ${BREAKPOINTS.md}px)`, context => {
        sections.forEach((section, index) => {
          const image = section?.querySelector(".drag");
          animations.set(image, {
            transformOrigin: index !== 0 ? "center right" : "center left",
            scaleX: index !== 0 ? 0.5 : 0.5,
            scaleY: 0.5,
          });
        });

        observer = animations.Observer.create({
          target: wrapperRef.current,
          onDrag: event => {
            if (!event.isDragging) return;
            handleMove(event);
          },
          onMove: event => {
            if (event.isDragging) return;
            handleMove(event);
          },
        });
      });

      setTimeout(() => {
        observer && observer.disable();

        const tl = animations.timeline({
          onComplete: () => {
            animations.ScrollTrigger.refresh();
            document.body.classList.toggle("disable-scroll", false);
          },
        });
        tl.to(
          left,
          {
            transformOrigin: "center left",
            rotationX: -95,
            perspective: 500,
            yPercent: -50,
            duration: 1,
          },
          0
        )
          .to(
            right,
            {
              transformOrigin: "center right",
              rotationX: -95,
              perspective: 500,
              yPercent: -50,
              duration: 1,
            },
            0
          )
          .to(
            wrapperRef.current,
            {
              scaleY: 0.1,
              height: 1,
              transformOrigin: "top top",
              duration: 1.2,
            },
            0
          );
      }, timeOut);
    };

    if (context.isDesktop) {
      initLoader();
    }

    return () => {
      if (observer) {
        observer.kill();
      }
    };
  }, []);

  return (
    <Wrapper ref={wrapperRef}>
      {imageSources.map((src, index) => (
        <ImageWrapper key={index} ref={ref => (imageRefs.current[index] = ref)}>
          <DragImageWrapper className="drag">
            <DragImage src={src} />
          </DragImageWrapper>
        </ImageWrapper>
      ))}
    </Wrapper>
  );
};

export default Loader;
